﻿
const domNodes = {
    checkBox: document.querySelectorAll<HTMLInputElement>("input[type='checkbox']")
};

var observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        var parent = mutation.target.parentElement !== null ? mutation.target.parentElement : new HTMLElement();
        if (mutation.type === "attributes") {
            if (mutation.attributeName === "disabled") {
                if (parent.classList.contains("disabled")) {
                    parent.classList.remove("disabled");
                } else {
                    parent.classList.add("disabled");
                }
            }
        }
    });
});

function addListenEvent() {
    [
        domNodes.checkBox
    ].forEach(node => {
        node.forEach(childNode => {
            observer.observe(childNode, {
                attributes: true
            });
        });

    });
}

const initialize = () => {
    addListenEvent();
};

initialize();
